import {
  Aperture,
  Clock,
  Contrast,
  Crop,
  Dices,
  FileImage,
  Gauge,
  Images,
  MessageSquare,
  Mic,
  Music,
  Ratio,
  Sparkles,
  Video,
  Volume2,
} from 'lucide-react'
import { humanizeLabel } from '@/shared/utils/generationPricing'

const PARAM_META: Record<string, { label: string; icon: React.ComponentType<{ className?: string }> }> = {
  prompt: { label: 'Prompt', icon: MessageSquare },
  negative_prompt: { label: 'Negative Prompt', icon: MessageSquare },
  aspect_ratio: { label: 'Aspect Ratio', icon: Ratio },
  ratio: { label: 'Aspect Ratio', icon: Ratio },
  resolution: { label: 'Resolution', icon: Aperture },
  image_resolution: { label: 'Resolution', icon: Aperture },
  duration: { label: 'Duration', icon: Clock },
  output_format: { label: 'Output Format', icon: FileImage },
  size: { label: 'Size', icon: Crop },
  image_size: { label: 'Size', icon: Crop },
  seed: { label: 'Seed', icon: Dices },
  guidance_scale: { label: 'Guidance Scale', icon: Gauge },
  guidance: { label: 'Guidance Scale', icon: Gauge },
  num_images: { label: 'Multiple Images', icon: Images },
  sound: { label: 'Sound', icon: Volume2 },
  generate_audio: { label: 'AI Audio', icon: Music },
  voice: { label: 'Voice', icon: Mic },
  stability: { label: 'Voice Stability', icon: Contrast },
  tts_style: { label: 'Voice Style', icon: Sparkles },
  speed: { label: 'Playback Speed', icon: Gauge },
  image_input: { label: 'Image Input', icon: FileImage },
  image_inputs: { label: 'Image Input', icon: FileImage },
  image_url: { label: 'Image Input', icon: FileImage },
  image_urls: { label: 'Image Input', icon: FileImage },
  input_urls: { label: 'Image Input', icon: FileImage },
  video_input: { label: 'Video Input', icon: Video },
  video_inputs: { label: 'Video Input', icon: Video },
}

export function getParamMeta(param: string): { label: string; icon: React.ComponentType<{ className?: string }> } {
  return PARAM_META[param] ?? { label: humanizeLabel(param), icon: Sparkles }
}
